import React from "react";
import { Link } from "gatsby";
import config from '../../../website-config';
const Footer = () => (
  <>
    <footer className="mainFooter">
      <div className="container">
        <div className="row footer-row">
          <div className="col-lg-2 col-md-2 footer-col intro-sec">
            <img data-sal="slide-up" className="logo-footer" src="BizDamnWhiteLogo.svg" alt="BizDamn Logo" />
          </div>
          <div className="col-lg-7 col-md-7">
            <div className="row">
              <div className="col-sm-6 footer-col">
                <div data-sal="slide-up" className="link-title">Important Links</div>

                <ul className="link-list">
                  <li><Link data-sal="slide-up" to="/consultancy">Free Website Audit </Link></li>
                  <li><Link data-sal="slide-up" to="/newsletter">Newsletter</Link></li>
                  <li><Link data-sal="slide-up" to="/technologies">Technologies We Use</Link></li>
                  <li><Link data-sal="slide-up" to="/website-packages">Website Packages</Link></li>
                </ul>
              </div>

              <div className="col-sm-6 footer-col">
                <div data-sal="slide-up" className="link-title">Resources</div>
                <ul className="link-list">
                  <li><Link data-sal="slide-up" to="/guides">Guides</Link></li>
                  <li><Link data-sal="slide-up" to="/books-summary"> Business Book Summaries</Link></li>
                  <li><Link data-sal="slide-up" to="/graphic-templates">Graphic Templates for Your Brand</Link></li>
                  <li><Link data-sal="slide-up" to="/tools-kit"> ToolsKit</Link></li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-3 footer-col">
            <div className="flex-column">
              <div data-sal="slide-up" className="link-title">Contact us</div>
              <ul className="link-list contact-list-footer with-mb">
                <li><a href={"tel:+" + config.callNumber} data-sal="slide-up"><i className="fas fa-phone-alt"></i> {config.callNumber}</a></li>
                <li><a data-sal="slide-up" href={"mailto:" + config.Email}><i className="fas fa-envelope"></i> {config.Email}</a></li>
                <li><Link data-sal="slide-up" to="/consultancy"><i className="fas fa-map-marker-alt"></i>  James Church, New Church Rd, Opp. St, Kashmere Gate, New Delhi, Delhi 110006</Link></li>
              </ul>

            </div>
            <p data-sal="slide-up" className="text-light text-center mb--0 mt--40 d-block d-sm-none">&copy; BizDamn</p>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-center">
        <p>
          <Link className='text-light' data-sal="slide-up" to="/privacy-policy">Privacy Policy  | </Link>
        </p>
        <p>
          <Link className='text-light' data-sal="slide-up" to="/terms-and-conditions">    Terms &amp; conditions </Link>
        </p>
      </div>
    </footer>

  </>
);
export default Footer;